import { Modal, Switch, Button } from 'antd';
import React, { useEffect } from 'react';
import './index.less';
import { ReactComponent as Warning } from '@/assets/icons/warning.svg';
import { api_config } from '../../../constants/api';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import actions from '../../../redux/action/index';
import axios from 'axios';
import Utils from '@/utils/index';
import PayModal from '@/components/allCommon/payBill/index.jsx';
import sentGAEvent from '@/ga';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import LoginComponent from '../../allCommon/login';
import V1cart from '@/utils/V1cart';
import sendGaEvent from '@/ga';
import Bingo from '@/assets/images/circle-bingo.svg';
import NoLimit from '@/assets/images/no_size_limit.svg';
import CurrentDevice from 'current-device';
const Exceed2M = () => {
  const { t } = useTranslation(['dynamicPhoto']);

  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const dispatch = useDispatch();
  const reducerData = useSelector((state) => state.common);
  const { exceed2M, authorization } = reducerData;
  const [selectIndex, setSelectIndex] = useState(0);
  const [highLight, setHighLight] = useState(0);
  const planArr = ['week', 'month', 'year'];
  useEffect(() => {
    if (reducerData.exceed2M.visible) {
      sendGaEvent({
        category: 'UpgradePrompShow',
        action: '22AO_UpgradePrompShow',
        label: 'Null',
      });
    }
  }, [reducerData.exceed2M]);

  const changeIndex = (index) => {
    setSelectIndex(index);
  };

  const onClose = () => {
    dispatch(actions.onExceed2M({ visible: false }));
  };
  const alreadySubscribe = () => {
    dispatch(actions.onExceed2M({ visible: false }));
    dispatch(
      actions.onSignUpModal({
        visible: true,
      })
    );
  };
  useEffect(() => {
    if (exceed2M?.type !== 'no_watermark' && exceed2M.type != 'gif') {
      switch (exceed2M.text) {
        case '"freeAccountExceed"':
          setHighLight(0);
          break;
        case 'UpgradeToUploadLimits':
          setHighLight(1);
          break;
        case 'freeAccountHD':
          setHighLight(2);
          break;
        case 'UpgradeToDownloadAsGIF':
          setHighLight(3);
          break;
        default:
          break;
      }
    }
  }, [exceed2M]);

  const getPurchase = () => {
    window.sessionStorage.cycle = `${selectIndex + 1}`;
    setPurchaseLoading(true);
    let site = Utils.getLanguage();
    site = site === 'tk' ? 'tr' : site === 'inn' ? 'in' : site;
    let plan = planArr[selectIndex];

    axios({
      method: 'POST',
      url: api_config.API_V2_URL + 'product-check-out',
      headers: {
        Authorization: authorization,
      },
      params: { plan: plan, site: site, FromProduct: 'dynamic-photo' },
    })
      .then((res) => {
        if (res.data.code === 200) {
          sentGAEvent({
            category: 'BuyNow',
            action: '22AO_BuyNow',
            label: 'Null',
          });
          let cartUrl = res.data.data.cart_url;
          console.log('res', res.data.data.cart_url);
          cartUrl = V1cart(cartUrl);
          window.open(cartUrl, '_blank');
        }
        setPurchaseLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPurchaseLoading(false);
      });
  };

  const list = [
    { content: t('SizeLimit'), img: Bingo },
    { content: t('UploadLimit'), img: Bingo },
    { content: t('DownloadNoWaterMark'), img: Bingo },
    { content: t('DownloadGIF'), img: Bingo },
  ];
  const priceList = [
    { plan: t('Weekly'), price: t('priceWeek') },
    {
      plan: t('Monthly'),
      price: t('priceMonth'),
      totalPrice: t('billMonth'),
      off: '50% OFF',
    },
    {
      plan: t('Yearly'),
      price: t('priceYear'),
      totalPrice: t('billYear'),
      off: '75% OFF',
    },
  ];
  return (
    <div>
      <Modal
        destroyOnClose
        className={`${
          CurrentDevice.mobile() ? 'mobileExceed20M' : 'exceed20M'
        } ${Utils.getLanguage() === 'ar' ? 'isAr' : ''}`}
        footer={null}
        maskClosable={false}
        centered
        visible={exceed2M.visible}
        onCancel={() => onClose()}
      >
        <div className='container'>
          <div className='leftContainer'></div>
          <div className='rightContainer'>
            {exceed2M.text ? (
              <div className='tips'>
                <span className='warning'>!</span> {t(`${exceed2M.text}`)}
              </div>
            ) : (
              ''
            )}

            <div className='title'>
              {t('DynamicTitle')} <span className='pro'>Pro</span>
            </div>
            <div className='listData'>
              {list.map((item, index) => {
                return (
                  <div
                    key={'dynamicList' + index}
                    className={`list ${highLight === index ? 'highLight' : ''}`}
                  >
                    <img
                      alt=''
                      src={highLight === index ? NoLimit : item.img}
                    />
                    {item.content}
                  </div>
                );
              })}
            </div>
            <div className='priceCard'>
              {priceList.map((item, index) => {
                return (
                  <div
                    key={'dynamicCard' + index}
                    className={`card ${
                      selectIndex === index ? 'selected' : ''
                    }`}
                    onClick={() => changeIndex(index)}
                  >
                    <div className='cardContainer'>
                      <div className='plan'>{item.plan}</div>
                      <div className='priceContainer'>
                        <span className='price'>{item.price}</span>
                        <span className='time'>/{t('purchase:week')}</span>
                      </div>
                    </div>
                    {selectIndex === index && item.totalPrice ? (
                      <div className='totalPrice'>{item.totalPrice}</div>
                    ) : (
                      ''
                    )}
                    {item.off ? <div className='save'>{item.off}</div> : ''}
                  </div>
                );
              })}
            </div>
            <div className='btnGroup'>
              <Button
                loading={purchaseLoading}
                className='buyNow'
                onClick={() => getPurchase()}
              >
                {t('common:BUY NOW')}
              </Button>
              {!Cookies.get('authorization') ? (
                <div className='subBtn' onClick={() => alreadySubscribe()}>
                  {t('AlreadySubscribe')}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Modal>
      <PayModal></PayModal>
      <LoginComponent />
    </div>
  );
};
export default Exceed2M;
